// What the signed-in person may do in Patients, Appointments and Treatment plans.
//
// The backend enforces staff permissions (middleware/staffPermissions.js) per
// module: 'none' refuses every read with 403 PERMISSION_DENIED, 'view' refuses
// every write. /api/patients is "Patients"; /api/appointments,
// /api/doctor-schedules and /api/facility-schedules are "Appointments";
// /api/patient-treatments, /api/treatments, /api/treatment-calls and
// /api/instruction-templates are "Treatment plans". The levels come from the
// shared GET /api/staff/me/permissions (useMyPermissions.js); anything that
// can't be read counts as 'edit', so a failed check never hides a working
// button; the global PermissionNotice toast still explains a refusal.
import { useModulePermission } from "../useMyPermissions";

/**
 * { loading, canEdit, viewOnly, noAccess } for one backend module
 * ("Patients", "Appointments", "Treatment plans"). While loading everything
 * stays enabled, so nobody sees buttons flicker off.
 */
export function useModuleAccess(module) {
  const a = useModulePermission(module);
  return { loading: a.loading, canEdit: a.canEdit, viewOnly: a.viewOnly, noAccess: a.noAccess };
}

/** A quiet line under a header: "View only: you can see Appointments but not change them." */
export function ViewOnlyNote({ module, className = "" }) {
  return <p role="note" className={`rounded-md bg-mist px-4 py-2.5 text-small text-muted ${className}`}>View only: you can see {module} but not change them. Ask an admin for edit access.</p>;
}

/** Tooltip for a control a view-only person can't use. */
export const viewOnlyTitle = (module) => `View only. Ask an admin for edit access to ${module}.`;
